import { useCopilotContext } from '@customerio/hydra-copilot/react';
import { ShowFeedbackTool } from './tools/feedback-tool';
import { ShowSupportFormTool } from './tools/support-tool';
import { SearchDocumentation } from './tools/search-documentation';

/**
 * Adds global configuration to the Copilot context.
 */
export function GlobalCopilotConfiguration() {
  useCopilotContext({
    description: 'The current URL',
    value: window.location.href,
  });

  useCopilotContext({
    description: 'The current URL title',
    value: document.title,
  });

  useCopilotContext({
    description: 'The current timezone',
    value: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });

  useCopilotContext({
    description: 'The current time',
    value: () => new Date().toISOString(),
  });

  return (
    <>
      <ShowFeedbackTool />
      <ShowSupportFormTool />
      <SearchDocumentation />
    </>
  );
}
